import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';

import {
  ContentTitleImagePipe,
  HasTitleImagePipe,
  getHomepageModuleToken,
  getOffers,
  IHomepageModelState,
  ImmomioIconName,
  IOffersState,
  LoadingType,
  OffersWidgetBaseComponent,
} from '@resident-nx/shared';
import { ROUTE } from '../../../models';
import { ContentCardPreset } from '../../molecules/content-card/content-card.model';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { ContentCardWebComponent } from '../../molecules/content-card/content-card.component';
import { CardsContainerHeaderWebComponent } from '../../molecules/cards-container-header/cards-container-header.component';
import { LoadingSkeletonWebComponent } from '../../atoms/loading-skeleton/loading-skeleton.component';

@Component({
  standalone: true,
  selector: 'rs-web-offers-widget',
  templateUrl: './offers-widget.component.html',
  styleUrls: ['./offers-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LoadingSkeletonWebComponent,
    CardsContainerHeaderWebComponent,
    ContentCardWebComponent,
    AsyncPipe,
    TranslateModule,
    RouterLink,
    ContentTitleImagePipe,
    HasTitleImagePipe,
  ],
})
export class OffersWidgetWebComponent extends OffersWidgetBaseComponent {
  @Input() override icon = ImmomioIconName.Tag;
  @Input() override title = 'news.offers_l';
  @Input() override buttonText = 'news.more_offers_a';

  public offersLimit = 5;
  public token$ = this.homepageStore.select(getHomepageModuleToken);
  public override offers$ = this.offersStore.select(getOffers);
  public preset = ContentCardPreset;
  public overviewLink = ['/', ROUTE.NEWS, ROUTE.OFFERS];
  protected readonly LoadingType = LoadingType;

  constructor(
    protected override offersStore: Store<IOffersState>,
    private homepageStore: Store<IHomepageModelState>
  ) {
    super(offersStore);
  }

  public onTap(offerId: string): void {
    this.tapped.emit(offerId);
  }

  public onTapOverview(): void {
    this.overviewTapped.emit();
  }

  public onTapHomepage(): void {
    this.homepageModuleTapped.emit();
  }
}
